import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "value"];
import { jsx as _jsx } from "react/jsx-runtime";
function createChangeHandler(changeCallback, key) {
  return newValue => changeCallback(key, newValue);
}

// High-order component to create a consistent API for adding form fields
// to the dialog.
export default function createFormField(WrappedComponent, key, defaultValue) {
  const FormField = _ref => {
    let {
        onChange,
        value
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      value: value,
      onChange: createChangeHandler(onChange, key)
    }, rest), key);
  };
  FormField.key = key;
  FormField.defaultValue = defaultValue;
  return FormField;
}